export function connectBookingUpdates(slug, handlers) {
  if (typeof window.EventSource !== 'function') throw new Error('Live updates are unsupported');
  const base = (import.meta.env.VITE_BASE_API_URL || '').replace(/\/$/, '');
  const source = new window.EventSource(`${base}/schedule/portal/${encodeURIComponent(slug)}/events`, { withCredentials: true });
  let closed = false;
  let watchdog;
  const alive = () => {
    clearTimeout(watchdog);
    watchdog = setTimeout(() => { if (!closed) handlers.onError(); }, 65000);
  };
  source.addEventListener('ready', () => { if (!closed) { alive(); handlers.onReady(); } });
  source.addEventListener('heartbeat', () => { if (!closed) alive(); });
  source.addEventListener('change', () => { if (!closed) { alive(); handlers.onChange(); } });
  source.addEventListener('expired', () => { if (!closed) handlers.onExpired(); });
  source.addEventListener('unavailable', () => { if (!closed) handlers.onError(); });
  source.addEventListener('reconnect', () => { if (!closed) handlers.onError(); });
  source.onerror = () => { if (!closed) handlers.onError(); };
  watchdog = setTimeout(() => { if (!closed) handlers.onError(); }, 10000);
  return () => { closed = true; clearTimeout(watchdog); source.close(); };
}
